import { createAsyncThunk } from "@reduxjs/toolkit";
import { FilterParamObj } from "../interface";
import { getDefaultView, getTileList, postTileUpdate } from "src/api/sp";
import { getFilterList, getMasterList } from "src/api/bi";

export const fetchMasterList = createAsyncThunk("dashboard/masterList", () => getMasterList());

export const fetchFilterList = createAsyncThunk(
    "dashboard/filterList",
    (filterParamObj: FilterParamObj) => getFilterList(filterParamObj)
);

export const fetchTilesData = createAsyncThunk("dashboard/tiles", async (storeId: string) => {
    const dashboardTiles = await getDefaultView(storeId);
    const customizerTiles = await getTileList(storeId);
    return { dashboardTiles, customizerTiles };
});

export const updateTilesData = createAsyncThunk("dashboard/updateTile", async (payload: any) => {
    const dashboardTiles = await postTileUpdate(payload);
    const customizerTiles = await getTileList(payload.storeId);
    return { dashboardTiles, customizerTiles };
});
